import React from 'react';
import { useDispatch } from 'react-redux';
import { HIDE_PILE } from '../REDUX/actions';
import _ from 'lodash';
import ShapeIcon from '../COMPONENTS/ShapeIcon';
import { windowSize } from '../../HOME/utils';

export const Pile = ({ tiles, shapes, colors }) => {
  const dispatch = useDispatch();

  const offsets = {};
  const { x: wx, y: wy } = windowSize();
  const vert = wx < wy;

  const renderTiles = () => {
    return _.map(tiles, (tile, i) => {
      const { shape, color } = tile;
      const key = `${shape} • ${color}`;
      const off = offsets[key] || 0;
      offsets[key] = off + 1;
      const dim1 = _.indexOf(colors, color) * 3 + 1 + off;
      const dim2 = _.indexOf(shapes, shape) + 1;
      const row = (vert ? dim1 : dim2) + 1;
      const col = vert ? dim2 : dim1;

      const style = { gridArea: `${row} / ${col}`, margin: `${vert ? `${wy < 700 ? 1 : 3}px 6px` : '6px 3px'}` };

      return (
        <div key={i} className="pn-pile-tile" id={tile.id} style={style}>
          <ShapeIcon shape={shape} color={color} width={22} />
        </div>
      );
    });
  };

  const style = { marginBottom: `${tiles.length ? '20px' : 0}` };

  return (
    <div className="pn-pile" onClick={() => dispatch(HIDE_PILE)}>
      <div className="pn-pile-header" style={style}>{`DRAW PILE${tiles.length ? '' : ' IS EMPTY'}`}</div>
      <div style={{ display: 'grid', gridArea: '2/1' }}>{renderTiles()}</div>
    </div>
  );
};

export default Pile;
